import { combineReducers } from 'redux';
import backendEngagementSurveyComparisonReducer from './comparison';
import backendEngagementSurveyResultsReducer from './result';

const backendEngagementSurveyReducer = combineReducers({
  result: backendEngagementSurveyResultsReducer,
  comparison: backendEngagementSurveyComparisonReducer,
});

export default backendEngagementSurveyReducer;
